import * as React from 'react'
import { cn } from '@repo/ui/lib/utils'

interface PremiumHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export function PremiumHeading({
  as: Component = 'h2',
  className,
  children,
  ...props
}: PremiumHeadingProps) {
  const sizeStyles = {
    h1: 'text-4xl md:text-5xl mb-6 tracking-tight',
    h2: 'text-2xl md:text-3xl mb-4 tracking-tight',
    h3: 'text-xl md:text-2xl mb-3',
    h4: 'text-lg md:text-xl mb-2',
    h5: 'text-base md:text-lg mb-2',
    h6: 'text-base mb-2',
  }

  return (
    <Component
      className={cn(
        'font-semibold text-[#f0f3f1]',
        sizeStyles[Component],
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  )
}
